import React,{useState,useEffect} from 'react'
import axios from 'axios'
import {useAuth} from '../index'
import { IoReturnDownBackSharp } from 'react-icons/io5'
import { IoMdKey } from 'react-icons/io'
import { LuEye, LuEyeClosed } from 'react-icons/lu'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export function UserInfoPage() {
    const {auth2FA2, user2, logout} = useAuth()
    const [edit, setEdit] = useState(false)
    const [userInfo, setUserInfo] = useState(null)
    const [updateData, setUpdateData] = useState({username:'',firstname:'',lastname:'',role:'',email:'',zipcode:'',address1:'',address2:'',country:''})
    const [TFA, setTFA] = useState(true)
    const [selectedRole, setSelectedRole] = useState('')
    const [msg, setMsg] = useState('')
    const [tokenHidden, setTokenHidden] = useState(true)
    useEffect(() => {
      if(userInfo==null){
        const handleSubmit = async (e) => {
          const { data: res } = await axios.post(`${APIURL}/account-info/bill`, {token:window.localStorage.getItem('token')})
          if(res.msg==='user info ok'){
            console.log(res.user)
            setUserInfo(res.user)
          }
          else{
            setMsg(res.msg)
            setTimeout(() => {
              localStorage.removeItem('user')
              localStorage.removeItem('token')
              logout()
            }, 3000)
          }
        }
        setTimeout(handleSubmit, 1)
      }
    })
    const onClick2Update = async()=>{
      //remove the item if it is empty
      const { data: res } = await axios.post(`${APIURL}/acccount-update`, {email:userInfo.email, updatedata:updateData,token:window.localStorage.getItem('token'),confirmed:`${Math.random().toString(36).substring(2)}`})
      const updateItems = res.user
      setUserInfo({...userInfo,...updateItems})
      setMsg(res.msg)
      if(updateData.email!=''){
        setTimeout(() => {
          setEdit(!edit)
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          logout()
        }, 5000)
      }else{
        setEdit(!edit)
        setUpdateData('')
        const remove = setTimeout(() => {
          setMsg('')
        }, 5000)
        return () => clearTimeout(remove)
      }
    }
    const onClick2Remove=async()=>{
        const { data: res } = await axios.post(`${APIURL}/acccount-remove`, {email:userInfo.email})
        setMsg(res.msg)
        setTimeout(() => {
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          logout()
        }, 3000)
    }
    const onChange2Input=({currentTarget:input})=>{
      setUpdateData({...updateData,[input.name]:input.value})
    }
    const onFocus2InputPwd = ({ currentTarget: input }) => {
      if(input.value==userInfo.pwdlen){
        console.log('it is default', input.value )
        setUpdateData({ ...updateData, [input.name]: '' })
      }
    }
    const onClick2CreateApiToken = async()=>{
      let apitoken=Math.random().toString(36).substring(2)
      apitoken+=Math.random().toString(36).substring(2)
      apitoken+=Math.random().toString(36).substring(2)
      apitoken+=Math.random().toString(36).substring(2)
      let apitokenlen=''
      for(let i=0; i<apitoken.length;i++){
        apitokenlen+='*'
      }
      console.log('create api token',apitoken)
      console.log('create api token',apitokenlen)
      const { data: res } = await axios.post(`${APIURL}/create-api-token`, {email:userInfo.email,apitoken:apitoken,apitokenlen:apitokenlen})
      const updateItems = res.user
      setUserInfo({...userInfo,...updateItems})
      setMsg(res.msg)
    }
    return (
         <>
        <div className='text-left m-auto md:mt-8 w-full md:w-[580px] lg:w-[780px]'>
        <h2 className='mb-4 text-lg structure__main__subttl'>User Infomation</h2>
        {userInfo==null?<div className='w-max m-auto mt-8 mb-8'><div className='secondary-loader'></div></div>:
        <>
        {edit?<>
        <div className='m-auto flex'>
        <div className='text-center'>
        <img src={userInfo.firstname!='' && userInfo.lastname!=''?`https://ui-avatars.com/api/?name=${userInfo.firstname[0]}+${userInfo.lastname[0]}&background=000&color=fff`:`https://ui-avatars.com/api/?name=${userInfo.email[0]}&background=000&color=fff`} className='structure__myaccount__avatar mb-1'/>
        {/* <button className='primary-btn'>Edit</button> */}
        </div>
        <div>
        <div className='flex mb-4'>
        <div className='bitter text-[11px] ml-1 md:ml-4 leading-[2.25] w-fit'>
         Username:<br/>
         Full Name:<br/>
         Email:<br/>
         Password:<br/>
         Confirm Password:<br/>
         {/* Two Factor Authentication:<br/>
         Account Membership:<br/> */}
         <br/>
        </div>
        <div className='ml-2 leading-[1.4]'>
        <input type='text' name='username' className='border border-gray-800 mb-[2px] text-[14px]' placeholder='username' onChange={onChange2Input}
         defaultValue={userInfo.username} /><br/>
        <input type='text' name='firstname' className='border border-gray-800 mb-[2px] text-[14px] md:w-32' placeholder='first name' onChange={onChange2Input}
         defaultValue={userInfo.firstname}/> <input type='text' name='lastname' className='border border-gray-800 mb-[2px] text-[14px] md:w-[252px]' placeholder='last name' onChange={onChange2Input}
         defaultValue={userInfo.lastname} /><br/>
        <input type='email' name='email' defaultValue={userInfo.email} className='border border-gray-800 mb-[2px] text-[14px] md:w-96' onChange={onChange2Input} /><br/>
        <input type='password' name='pwd' defaultValue={userInfo.pwdlen} value={updateData.pwd} className='border border-gray-800 mb-[2px] text-[14px]' onFocus={onFocus2InputPwd} onChange={onChange2Input} /><br/>
        <input type='password' name='confirm_password' defaultValue={userInfo.pwdlen} value={updateData.confirm_password} onFocus={onFocus2InputPwd} className='border border-gray-800 mb-[2px] text-[14px]' onChange={onChange2Input}/><br/>
        </div>
        </div> 
        {/* <div className='flex mb-4'>
        <div className='ml-4 leading-[2] w-64'>
         Billing Address:
        </div>
        <div className='ml-2'>
         <input type='text' name='zipcode' className='border border-gray-800 mb-1' onChange={onChange2Input} placeholder='zipcode' defaultValue={userInfo.zipcode}/><br/>
         <input type='text' name='address1' className='border border-gray-800 mb-1 w-96' onChange={onChange2Input}  placeholder='Address1 Apartment room number, Street name' defaultValue={userInfo.address1}/><br/>
         <input type='text' name='address2' className='border border-gray-800 mb-1 w-96' onChange={onChange2Input}  placeholder='Address2 City' defaultValue={userInfo.address2}/><br/>
         <input type='text' name='country' className='border border-gray-800 mb-1' onChange={onChange2Input}  placeholder='Country' defaultValue={userInfo.country}/><br/><br/>
        </div>
        </div>
        <div className='flex mb-4'>
        <div className='ml-4 leading-[2] w-64'>
        Card Infomation:
        </div>
        <div className='ml-2'>
         <input type='text' name='acnumber' className='border border-gray-800 mb-1 mr-1 w-[252px]' onChange={onChange2Input}  placeholder='A/C Number'
         //defaultValue={userInfo.acnumber}
         /><input type='text' name='acsecurecode' className='border border-gray-800 mb-1 w-32' onChange={onChange2Input}  placeholder='Secure Code'
         //defaultValue={userInfo.acsecurecode}
         /><br/>
         <input type='text' name='acholdername' className='border border-gray-800 mb-1 w-96' onChange={onChange2Input}  placeholder='A/C Holder Name'
         //defaultValue={userInfo.acholdername}
         /><br/>
         <input type='text' name='acexpirerymonth' className='border border-gray-800 mb-1 w-10' onChange={onChange2Input}  placeholder='MM'
         //defaultValue={userInfo.acholdername}
         /> <input type='text' name='acexpireryyear' className='border border-gray-800 mb-1 w-16' onChange={onChange2Input}  placeholder='YYYY'
         //defaultValue={userInfo.acholdername}
         /><br/>
        </div>
        </div> */}
        </div>
       </div>
       <div className='mt-4 flex justify-center'><button className='bitter hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-[24px] text-[13px] pl-[12px] pr-[12px] text-white mr-[2px] font-medium' onClick={()=>setEdit(!edit)}>Cancel</button><button className='bitter hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-[24px] text-[13px] pl-[12px] pr-[12px] text-white font-medium' onClick={onClick2Update} disabled={!(updateData.username || updateData.firstname || updateData.lastname || updateData.pwd && updateData.confirm_password|| updateData.role || updateData.zipcode || updateData.address1 || updateData.address2 || updateData.country || updateData.email )}>Save Change</button></div>
       </>:<>{userInfo.username===''?<div className='w-max m-auto mt-8 mb-8'><div className='secondary-loader'></div></div>:<><div className='m-auto flex text-xs'>
        <div>
        <img src={userInfo.firstname!='' && userInfo.lastname!=''?`https://ui-avatars.com/api/?name=${userInfo.firstname[0]}+${userInfo.lastname[0]}&background=000&color=fff`:`https://ui-avatars.com/api/?name=${userInfo.email[0]}&background=000&color=fff`} className='structure__myaccount__avatar'/>
        </div>
        <div>
        <div className='flex leading-[2] mb-4 primary-text'>
        <div className='bitter text-[11px] ml-4 w-fit md:w-64'>
         Username:<br/>
         Full Name:<br/>
         Email:<br/>
         Password:<br/>
         {/* Two Factor Authentication:<br/> */}
         API Token:<br/>
         Membership:<br/>
         Next membership payment date:<br/>
         Login Token Issued Date:<br/>
         Login Expirery Date:<br/>
        </div>
        <div className='ml-2'>
         {userInfo.username}<br/>
         {userInfo.firstname} {userInfo.lastname}<br/>
         {userInfo.email}<br/>
         {userInfo.pwdlen}<br/>
         {userInfo.apitokenlen!=0? <>{tokenHidden?<div className='flex'>{userInfo.apitokenlen}<LuEyeClosed onClick={()=>setTokenHidden(!tokenHidden)} className='ml-[4px] mt-[2px]'/></div>:<div className='flex'>{userInfo.apitoken}<LuEye onClick={()=>setTokenHidden(!tokenHidden)} className='ml-[4px] mt-[4px]'/></div>}</>:<button className='bg-gray-300 hover:bg-gray-200 ] border-gray-800 text-[9px] pl-[8px] pr-[8px] flex' onClick={onClick2CreateApiToken}>Create API Token <IoMdKey className='ml-[2px] mt-[1px] text-[18px]'/></button>}
         <></>
         {/* {userInfo.twofaVerification}<br/>*/}
         {userInfo.membership}<br/> 
         {userInfo.membership!='free'?<>{userInfo.next_payment}</>:<span className='ml-[8px]'> -</span>}<br/> 
         {userInfo.iat}<br/>
         {userInfo.exp}<br/>
        </div>
        </div>
        {/* <div className='flex leading-[2] mb-4 primary-text'>
        <div className='ml-4 w-64'>
         Billing Address:
        </div>
        <div className='ml-2'>
         {userInfo.zipcode}<br/>
         {userInfo.address1}<br/>
         {userInfo.address2}<br/>
         {userInfo.country}<br/>
        </div>
        </div>
        <div className='flex leading-[2] mb-4 primary-text'>
        <div className='ml-4 w-64'>
         Card Infomation:
         <br/>
        </div>
        <div className='ml-2'>
         Number, 3-4 digit Code<br/>
         A/C Holder Name<br/>
         MM/YYYY<br/>
        </div>
        </div> */}
        </div>
        </div>
        <div className='mt-4 flex justify-center'><button className='primary-btn primary-text mr-1' onClick={onClick2Remove}>Delete Account</button><button className='primary-btn primary-text' onClick={()=>setEdit(!edit)}>Change Information</button></div>
        </>
       }</>
       }
       </>
       }
       <div className='mt-[1em] text-center mb-2 text-[12px]'>{msg}</div>
       <br/><br/>
       </div>
    </>
    )
}
